<template>
  <div v-if="visible" id="help" class="notification has-background-grey-darker">
    <b>{{ $t('help') }}</b>
    <ul>
      <li>{{ $t('help.click') }}</li>
      <li>{{ $t('help.timebar') }}</li>
      <li>{{ $t('help.layer') }}</li>
      <li>{{ $t('help.qgis') }}</li>
      <li v-if="$conf.tilesets.layers.length > 0">{{ $t('help.parcelts') }} <a :href="$t('help.parceltslink')">{{ $t('help.parceltsapiname') }}</a></li>
      <li>{{ $t('help.ardapi') }} <a :href="$t('help.ardapilink')">{{ $t('help.ardapiname') }}</a></li>
      <li>{{ $t('help.wmsexamples') }} <a href="#" @click="openPlaygroundModal">{{ $t('help.wmsexampleslink') }}</a></li>
    </ul>
  </div>
</template>

<script>

import Playground from 'comp/Playground'

export default {
  name: 'HelpComponent',
  data () {
    return {
      visible: true
    }
  },
  computed: {

  },
  methods: {
    openPlaygroundModal (e) {
      e && e.preventDefault()
      this.$buefy.modal.open({
        parent: this,
        width: 1200,
        component: Playground,
        hasModalCard: true,
        canCancel: ['escape', 'outside']
      })
    }
  }
}

</script>

<style lang="stylus" scoped>

#help
  margin: 0px 6px 26px 6px
  padding: 0
  ul
    list-style-type: disc
    padding-left: 20px

</style>
